import { Box, useMantineTheme } from "@mantine/core"
import {
  CalendarAppointment,
  eCalendarAppointmentSource,
  eCalendarAppointmentSource_AllValues,
} from "../../../../../../../@client/Theasoft_ApiServer_Calendar"

interface Props {
  parentWidth: number
  parentHeight: number
  appointments: CalendarAppointment[]
}

export function CalendarAppointmentIndicator({
  appointments,
  parentHeight,
  parentWidth,
}: Props) {
  const { indicatorColor, indicatorFilled } = appointments.reduce(
    (result, appointment) => {
      if (
        result.colorPriority === undefined ||
        eCalendarAppointmentSource_AllValues.indexOf(result.colorPriority) <
          eCalendarAppointmentSource_AllValues.indexOf(appointment.source)
      ) {
        result.colorPriority = appointment.source
        result.indicatorColor = appointment.backColorHEX
        result.indicatorFilled =
          appointment.source === "Cast" || appointment.source === "Duty"
      }
      return result
    },
    {
      indicatorColor: undefined as undefined | string,
      indicatorFilled: undefined as boolean | undefined,
      colorPriority: undefined as eCalendarAppointmentSource | undefined,
    }
  )

  const size = Math.floor(((parentWidth + parentHeight) / 2) * 0.35)

  const theme = useMantineTheme()

  const color = appointments?.length
    ? (indicatorColor ?? theme.primaryColor)
    : undefined

  return (
    <Box
      w={size}
      h={size}
      bg={indicatorFilled ? color : undefined}
      mb={3}
      style={{
        borderRadius: 3,
        border: indicatorFilled
          ? "1px solid"
          : appointments?.length
            ? "2px solid"
            : "",
        borderColor: indicatorFilled
          ? theme.colors.dark[2]
          : theme.colors[theme.primaryColor][5],
        transform: "rotate(45deg)",
        boxShadow:
          indicatorColor || indicatorFilled === false
            ? "0 0 1px rgba(0,0,0,1)"
            : undefined,
        maxHeight: "1.5rem",
        maxWidth: "1.5rem",
      }}
    />
  )
}
